import React from "react";

export function ThumbsUpIcon({ filled = false, size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      color="currentColor"
    >
      <path d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" />
      <path d="M7 22V11l3-8a1 1 0 011-1h1a2 2 0 012 2v4h5.5a2 2 0 012 1.94l-.5 7A2 2 0 0118.97 19H7z" />
    </svg>
  );
}
